import { Outlet } from "react-router-dom";
import { SettingsProvider } from "./provider/SettingsProvider";
import SettingsComponents from "./SettingsComponents";
import SettingsSidebar from "./SettingsSidebar";

const SettingsIndexWrapper = () => {
    return (
        <SettingsProvider>
            <div className="flex flex-grow flex-col 3xl:pt-4 4xl:px-10 animate-slide-down">
                <div className="page-container flex w-full flex-col flex-nowrap lg:flex-row">
                    <div className="sidebar w-full lg:w-[20vw] lg:shrink-0">
                        <SettingsSidebar />
                    </div>
                    <div className="content h-full w-full min-w-0 flex-1 p-4">
                        <Outlet />
                        <SettingsComponents />
                    </div>
                </div>
            </div>
        </SettingsProvider>
    )
}

export default SettingsIndexWrapper;
